import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";

// Create the context
const AppContext = createContext();

// Create the provider component
export const AppProvider = ({ children }) => {
  // --- Existing Session Management State ---
  const [sessions, setSessions] = useState([]);

  const fetchSessions = async () => {
    try {
      // Ensure REACT_APP_BACKEND_URL is correctly set in your .env file
      // and the user ID is dynamic if it's not always '6809e4dc4dc37a97bf959d91'
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/get-all-sessions/6809e4dc4dc37a97bf959d91`
      );
      setSessions(response.data.responseData); // Adjust based on actual response shape
    } catch (error) {
      console.error("Error fetching sessions:", error);
    }
  };

  useEffect(() => {
    fetchSessions();
  }, []);


  const [adminToken, setAdminToken] = useState(() => {
    return localStorage.getItem('adminToken') || null;
  });

  const isAdminLoggedIn = !!adminToken;

  const loginAdmin = (token) => {
    localStorage.setItem('adminToken', token);
    setAdminToken(token);
  };

  const logoutAdmin = () => {
    localStorage.removeItem('adminToken');
    setAdminToken(null);
  };

  const contextValue = {
    sessions,
    setSessions,
    fetchSessions,

    // Admin authentication values
    adminToken,        // You might expose this if components need the token itself
    isAdminLoggedIn,   // Boolean status for protection
    loginAdmin,        // Function to log in
    logoutAdmin        // Function to log out
  };

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to consume the context
export const useAppContext = () => useContext(AppContext);
// Removed default export for useAppContext, now it's a named export, consistent with AppProvider